import React from 'react';
export var defaultTheme = {
    icons: {},
    colors: {},
    fontFamily: {},
};
var defaultContextValue = {
    theme: defaultTheme,
    setTheme: function () { return undefined; },
};
export var TrilogyThemeContext = React.createContext(defaultContextValue);
export var TrilogyThemeProvider = function (_a) {
    var children = _a.children;
    return children;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvdmlkZXJUaGVtZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL2NvbnRleHQvcHJvdmlkZXJUaGVtZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxLQUE4QyxNQUFNLE9BQU8sQ0FBQTtBQUdsRSxNQUFNLENBQUMsSUFBTSxZQUFZLEdBQWtCO0lBQ3pDLEtBQUssRUFBRSxFQUFFO0lBQ1QsTUFBTSxFQUFFLEVBQUU7SUFDVixVQUFVLEVBQUUsRUFBRTtDQUNmLENBQUE7QUFPRCxJQUFNLG1CQUFtQixHQUFHO0lBQzFCLEtBQUssRUFBRSxZQUFZO0lBQ25CLFFBQVEsRUFBRSxjQUFNLE9BQUEsU0FBUyxFQUFULENBQVM7Q0FDMUIsQ0FBQTtBQUVELE1BQU0sQ0FBQyxJQUFNLG1CQUFtQixHQUFHLEtBQUssQ0FBQyxhQUFhLENBQXVCLG1CQUFtQixDQUFDLENBQUE7QUFFakcsTUFBTSxDQUFDLElBQU0sb0JBQW9CLEdBQUcsVUFBQyxFQUFxQztRQUFuQyxRQUFRLGNBQUE7SUFDN0MsT0FBTyxRQUFRLENBQUE7QUFDakIsQ0FBQyxDQUFBIn0=